// Récupérer les sous-événements pour une date donnée et les trier par participation
export const getSubEventsForDate = (events, date) => {
  const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  const subEventsForDate = [];

  // Parcourir tous les événements
  events.forEach(event => {
    // Vérifier si la date est dans la période de l'événement
    if (isDateInEventPeriod(event, date)) {
      // Récupérer les sous-événements de cette date précise
      const daySubEvents = event.subEvents.filter(subEvent => subEvent.date === dateStr);

      // Ajouter les infos de l'événement parent à chaque sous-événement
      daySubEvents.forEach(subEvent => {
        subEventsForDate.push({
          ...subEvent,
          parentEvent: {
            id: event.id,
            title: event.title,
            color: event.circuit?.color || 'bg-blue-600',
            logoUrl: event.circuit?.logoUrl,
            circuit: event.circuit,
            startDate: event.startDate,
            endDate: event.endDate
          }
        });
      });
    }
  });

  // Trier : sous-événements avec participation en premier
  return subEventsForDate.sort((a, b) => {
    if (a.participating && !b.participating) return -1;
    if (!a.participating && b.participating) return 1;
    // Si même statut de participation, trier par heure
    return a.time.localeCompare(b.time);
  });
};

// Vérifier si une date est dans la période d'un événement
export const isDateInEventPeriod = (event, date) => {
  const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  return dateStr >= event.startDate && dateStr <= event.endDate;
};

// Récupérer tous les événements qui sont actifs sur une période donnée
export const getActiveEventsForDate = (events, date) => {
  return events.filter(event => isDateInEventPeriod(event, date));
};

// Récupérer tous les événements d'un mois
export const getEventsForMonth = (events, year, month) => {
  return events.filter(event => {
    const eventStartDate = new Date(event.startDate);
    const eventEndDate = new Date(event.endDate);
    const monthStart = new Date(year, month, 1);
    const monthEnd = new Date(year, month + 1, 0);

    // L'événement chevauche le mois si :
    // - Il commence dans le mois, OU
    // - Il se termine dans le mois, OU
    // - Il englobe tout le mois
    return (eventStartDate <= monthEnd && eventEndDate >= monthStart);
  });
};

// Trouver un événement par son ID
export const findEventById = (events, eventId) => {
  return events.find(event => event.id === parseInt(eventId));
};

// Trouver un sous-événement dans un événement
export const findSubEventById = (event, subEventId) => {
  if (!event || !event.subEvents) return null;
  return event.subEvents.find(subEvent => subEvent.id === parseInt(subEventId));
};

// Obtenir la durée d'un événement en jours
export const getEventDurationInDays = (event) => {
  const start = new Date(event.startDate);
  const end = new Date(event.endDate);
  const diffTime = Math.abs(end - start);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 pour inclure le dernier jour
};

// Formater la période d'un événement
export const formatEventPeriod = (event) => {
  const start = new Date(event.startDate);
  const end = new Date(event.endDate);

  // Si même jour
  if (event.startDate === event.endDate) {
    return start.toLocaleDateString('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  // Si même mois
  if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
    return `Du ${start.getDate()} au ${end.getDate()} ${start.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}`;
  }

  // Si mois différents
  return `Du ${start.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' })} au ${end.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}`;
};